(function(){
  function initGhc(root){
    var track = root.querySelector('.ghc-cards-track');
    if(!track || track.children.length === 0) return;

    var progressFill = root.querySelector('.ghc-progress-fill');
    var numStart = root.querySelector('.ghc-num-start');
    var prevBtn = root.querySelector('.ghc-prev');
    var nextBtn = root.querySelector('.ghc-next');
    var total = track.children.length;

    var index = 0;
    var cardStep = 0;

    function measure(){
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      cardStep = track.children[0].getBoundingClientRect().width + gap;
    }

    function render(animate){
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(-' + (index * cardStep) + 'px)';
      if(numStart) numStart.textContent = String(index + 1).padStart(2, '0');
      if(progressFill) progressFill.style.width = ((index + 1) / total * 100) + '%';
      if(prevBtn) prevBtn.disabled = index === 0;
      if(nextBtn) nextBtn.disabled = index === total - 1;
    }

    function goTo(i){
      index = Math.max(0, Math.min(total - 1, i));
      render();
    }

    if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(index + 1); });
    if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(index - 1); });

    window.addEventListener('resize', function(){ measure(); render(false); });

    // drag / swipe
    var startX = 0, currentTranslate = 0, dragging = false;

    function pointerDown(e){
      dragging = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      currentTranslate = -index * cardStep;
      track.classList.add('ghc-dragging');
    }
    function pointerMove(e){
      if(!dragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      track.style.transform = 'translateX(' + (currentTranslate + (x - startX)) + 'px)';
    }
    function pointerUp(e){
      if(!dragging) return;
      dragging = false;
      track.classList.remove('ghc-dragging');
      var x = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX);
      var delta = x - startX;
      if(Math.abs(delta) > cardStep * 0.2){
        goTo(delta < 0 ? index + 1 : index - 1);
      } else {
        render();
      }
    }

    track.addEventListener('mousedown', pointerDown);
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);
    track.addEventListener('touchstart', pointerDown, { passive: true });
    track.addEventListener('touchmove', pointerMove, { passive: true });
    track.addEventListener('touchend', pointerUp);

    measure();
    render(false);

    // autoplay
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4500;
    var timer = null;

    function startAutoplay(){
      if(!autoplayEnabled || total < 2) return;
      stopAutoplay();
      timer = setInterval(function(){
        goTo(index + 1 >= total ? 0 : index + 1);
      }, autoplaySpeed);
    }
    function stopAutoplay(){
      if(timer) clearInterval(timer);
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    startAutoplay();
  }

  document.querySelectorAll('.ghc-root').forEach(initGhc);

  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector ? e.target.querySelector('.ghc-root') : null;
    if(root) initGhc(root);
  });
})();
